var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.22 39.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #001e5d;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOOK_1",
    "data-name": "LOOK 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.65,32.39c-.12-.07-.33-.13-.53-.13-.5,0-.71.41-.71,1.17v.62h1.08v.57h-1.08v4.56h-.8v-4.56h-.82v-.57h.82v-.62c0-1.33.65-1.78,1.53-1.78.34,0,.59.1.75.18l-.24.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.76,34.74c-.14-.09-.38-.26-.62-.26-.81,0-1.31.75-1.31,1.43v3.27h-.81v-5.12h.72l.04.78c.17-.37.68-1.02,1.55-1.02.34,0,.64.14.73.21l-.31.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m27.1,39.29c-1.53,0-2.28-.99-2.28-2.78,0-1.45.72-2.7,2.28-2.7s2.28,1.05,2.28,2.7c0,1.53-.72,2.78-2.28,2.78m0-4.87c-1.06,0-1.46,1.08-1.46,2.09,0,1.26.43,2.19,1.46,2.19,1.15,0,1.47-1.13,1.47-2.19,0-1.14-.4-2.09-1.47-2.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.22,39.17h-.8v-3.51c0-.85-.49-1.24-1.1-1.24-.83,0-1.29.88-1.29,1.27v3.49h-.79v-3.51c0-.85-.5-1.24-1.1-1.24-.83,0-1.29.88-1.29,1.27v3.49h-.8v-5.12h.72l.04.76c.24-.54.82-.99,1.68-.99.81,0,1.29.44,1.47,1.05.2-.51.79-1.05,1.72-1.05s1.54.56,1.54,1.66v3.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.34 32.87 46.34 39.17 44.97 39.17 44.97 32.87 42.48 32.87 42.48 31.77 48.82 31.77 48.82 32.87 46.34 32.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.15 39.17 50.15 31.78 55.1 31.78 55.1 32.85 51.52 32.85 51.52 34.8 54.82 34.8 54.82 35.85 51.52 35.85 51.52 38.07 55.24 38.07 55.24 39.17 50.15 39.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "56.91 39.17 56.91 31.78 58.29 31.78 58.29 38.07 61.95 38.07 61.95 39.17 56.91 39.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.55 39.17 63.55 31.78 68.51 31.78 68.51 32.85 64.93 32.85 64.93 34.8 68.23 34.8 68.23 35.85 64.93 35.85 64.93 38.07 68.65 38.07 68.65 39.17 63.55 39.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "71.7 32.86 71.7 34.87 75.07 34.87 75.07 35.93 71.7 35.93 71.7 39.17 70.32 39.17 70.32 31.78 75.33 31.78 75.33 32.86 71.7 32.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "76.92 39.17 76.92 31.78 78.29 31.78 78.29 38.07 81.95 38.07 81.95 39.17 76.92 39.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.56 39.17 83.56 31.78 88.51 31.78 88.51 32.85 84.93 32.85 84.93 34.8 88.23 34.8 88.23 35.85 84.93 35.85 84.93 38.07 88.65 38.07 88.65 39.17 83.56 39.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.08 39.17 93.08 36.19 91.04 39.17 89.4 39.17 92.23 35.33 89.62 31.78 91.34 31.78 93.16 34.52 94.93 31.78 96.58 31.78 93.98 35.33 96.8 39.17 95.08 39.17"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.91,23.96c-.6-.03-2.76-.03-3.29,0-.91-2.74-2.04-5.91-3.29-8.92h-7.96c-1.1,2.91-2.22,5.81-3.11,8.92-.43-.03-1.91-.03-2.25,0L10.12,0l9.79,23.96ZM9.35,5.21l-3.4,8.01h6.55l-3.15-8.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.68,11.76c.43.03,2.28.09,3.88-.24,2.29-.5,4.02-2.14,4.02-4.72,0-2.28-1.1-3.76-3.45-4.16-1.16-.2-3.29-.1-4.6-.04v21.35c-.51-.03-2.32-.03-2.76,0V1.38h6.65c4.83,0,6.96,1.68,6.96,5.02,0,3.83-3.26,5.68-6.43,6.27l8.56,11.28c-.66-.03-3.04-.03-3.61,0-.69-1.02-9.21-12.2-9.21-12.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m48.68,13.07c-.32-7.22,4.17-11.98,10.1-12.24,5.4-.23,11.02,2.89,11.37,10.81.32,7.35-4,12.36-10.4,12.65-6.34.27-10.76-4.16-11.07-11.22m16.54-8.22c-1.52-2.02-3.81-3.04-6.11-2.94-5.05.22-7.9,4.74-7.61,11.43.3,6.7,4,10.04,8.28,9.84,6.05-.26,7.92-7.55,7.56-11.17-.11-2.73-.54-5.03-2.12-7.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.87,1.38c.44.04,2.23.04,2.73,0,.32,1.12.58,2.31.88,3.5l1.73,6.7,2.47,8.71h.26c1.89-6.04,5-16.11,5.7-18.92.26.04,1.38.04,1.68,0,.56,2.35,2.94,9.87,5.58,18.92h.27c.44-1.26.82-2.5,1.18-3.76l3.43-12.44.71-2.71c.32.04,1.68.04,2.06,0-.53,1.36-1.03,2.77-1.47,4.23l-5.61,18.35c-.35-.04-1.62-.04-1.94,0-.35-1.29-3.46-12.05-5.31-18.52h-.24l-5.7,18.52c-.35-.04-1.65-.04-1.97,0-.41-1.52-.76-2.94-1.17-4.36l-5.25-18.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.97,11.77c.44.04,2.28.09,3.88-.24,2.29-.49,4.02-2.14,4.02-4.72,0-2.28-1.1-3.76-3.45-4.16-1.16-.2-3.29-.09-4.61-.03v21.35c-.5-.03-2.32-.03-2.76,0V1.39h6.65c4.83,0,6.96,1.69,6.96,5.02,0,3.84-3.26,5.68-6.42,6.27l8.56,11.29c-.66-.03-3.04-.03-3.61,0-.69-1.02-9.22-12.2-9.22-12.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m100.3,1.85v2.74h-.6V1.85h-1.08v-.48h2.75v.48h-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m104.62,4.59l-.11-2.44-.81,2h-.54l-.83-2-.1,2.44h-.58l.19-3.21h.74l.88,2.13.83-2.13h.74l.19,3.21h-.6Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.404660d6aa448086529b727ac210fe8b.svg";
export { ForwardRef as ReactComponent };